/* eslint-disable radix */
/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid, react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { Rules } from '../../../../helpers/RHFRules';
import { calculateCheckDigit } from '../../../../helpers/generalUtils';
import Loading from '../../../../components/crosscutting/Loading';
import AlertConfirm from '../../../../components/crosscutting/confirmationWindows/AlertConfirmEditCustomer';
import ObservationsConfirm from '../../../../components/crosscutting/confirmationWindows/ObservationsConfirm';
import WarningIcon from '../../../../components/IconsLibrary/WarningIcon';

import {
  resetFormRegisterAction,
} from '../../../../actions/purchaseLicense.action';

import ImagePopup from '../../../../assets/img/iconos/license/SuccesfullIcon.svg';
import WarningPopup from '../../../../assets/img/iconos/license/WarningIcon.svg';

import { updateCustomerAction, getCustomerInformationLicenseAction, getCustomerEditInformationLicenseAction } from '../../../../actions/license.action';

import { getParametersCustomerAction, getTokenExternalSourceAction } from '../../../../actions/general.action';
import { setGeoCode } from '../../../../helpers/googleMapsUtils';

import CustomInput from '../../../../components/form/CustomInput';
import CustomSelect from '../../../../components/form/CustomSelect';
import CustomAutocompleteSelect from '../../../../components/form/Autocomplete/CustomAutocompleteSelect';
import AutocompleteGoogleMaps from '../../../../components/form/AutocompeteGoogleMaps/CustomAutocompleteGoogleMaps';

const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'linear-gradient(#FFFFFFCC, #ffffff)',
    borderRadius: '30px',
    opacity: 1,
    padding: '5px',
    marginTop: '20px',
  },
  paperGroup: {
    backgroundColor: '#fff',
    margin: 20,
    borderRadius: 10,
    border: '1px solid #32ACDE',
    padding: 20,
  },
  title: {
    ...theme.backOffice.configurations.title,
    fontWeight: 600,
    fontSize: '26px',
    paddingTop: '15px',
    paddingLeft: '20px',
  },
  button: {
    background: 'var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box',
    border: '1px solid var(--unnamed-color-707070)',
    backgroundColor: '#FFFFFF 0% 0 % no - repeat padding- box',
    borderRadius: '5px',
    opacity: '1',
    font: 'normal normal 600 12px/34px Muli',
  },
  root: {
    width: '100%',
    marginTop: '10%',
    marginBottom: '10%',
    padding: '20px',
    borderRadius: '14px',
    ...theme.registerForm.masterContainer,
  },
  titleForm: {
    color: '#1D71B8',
    textAlign: 'left',
    letterSpacing: '0px',
    opacity: '1',
    fontWeight: 'bold',
  },
  divider: {
    marginBottom: '10px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    borderColor: theme.palette.primary.main,
    ...theme.registerForm.containerForm,
  },
  rowWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  margin: {
    margin: theme.spacing(1),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  contentTextPrimary: {
    color: theme.palette.primary.main,
  },
  contentTextSecondary: {
    color: theme.palette.secondary.main,
    fontSize: 15,
  },
  contentInfoAddress: {
    color: '#77CAED',
  },
  submit: {
    paddingTop: 20,
    textAlign: 'center',
    padding: 10,
  },
  submitLicense: {
    textAlign: 'left',
    padding: 10,
  },
  btnSubmit: {
    marginLeft: 10,
    fontSize: 16,
    width: 200,
    borderRadius: 10,
    fontWeight: 100,
    '&:disabled': {
      opacity: 0.4,
      fontWeight: 100,
      backgroundColor: '#1D71B8',
      color: 'white',
    },
  },
  btnSubmitLicense: {
    borderRadius: '5px',
    border: '1px solid #E45501',
    color: '#E55200',
    '&:disabled': {
    },
  },
  imgLicense: {
    height: '20px',
    width: '30px',
    paddingLeft: '5px',
    marginTop: '2px',
  },
  panelSummary: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    maxHeight: '50px',
    borderRadius: 4,
  },
  expanded: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    borderRadius: 4,
    borderColor: theme.palette.secondary.main,
    '&$expanded': {
      minHeight: '0px',
      maxHeight: '50px',
    },
  },
  infoText: {
    color: theme.palette.secondary.main,
    marginTop: -23,
    fontSize: theme.typography.pxToRem(16),
    position: 'absolute',
  },
  legalTerms: {
    padding: '20px',
  },
  legalTermsPolicy: {
    marginTop: '7px',
    marginLeft: '-40px',
  },
  formErrors: {
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(13),
  },
  buttonProgress: {
    color: theme.palette.error.main,
    top: '10px',
    marginLeft: '10px',
    position: 'relative',
  },
  expansionPanelTitle: {
    color: '#212121',
    fontWeight: 'bold',
    fontSize: 16,
  },
  expansionPanelIcon: {
    color: '#212121',
  },
  btnCashPayment: {
    display: 'none',
  },
  alertActivation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleActivated: {
    paddingTop: '60px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  logoActivated: {
    paddingTop: '50px',
    paddingBottom: '30px',
  },
  messageActivated: {
    fontSize: 17,
    textAlign: 'center',
  },
  secondaryMessageAlert: {
    textAlign: 'center',
    color: '#7b7b7b',
    paddingTop: 15,
    paddingBottom: 20,
  },
  typeInput: {
    '& .MuiOutlinedInput-root': {
      position: 'relative',
      borderRadius: '10px',
      boxShadow: '1px 5px 5px #d7d7d7',
    },
  },
  dateCustom: {
    '& .MuiIconButton-root': {
      color: '#009fe3',
    },
  },
}));

const personType = [
  { value: 'J', label: 'Persona Juridica' },
  { value: 'N', label: 'Persona Natural' },
];

const EditCustomer = (props) => {
  const classes = useStyles();
  const {
    getParametersCustomer, documentTypes, statesAndCities,
    getTokenExternalSource, setEditCustomer, setShowListCustomers,
    resetFormRegister, citiesServGoogleAssistant, idCustomerEdit,
    setIdCustomerEdit, loadingCustomerEdit, getCustomerEditInformationLicense,
    customerServiceEditInfoLicense, loading, updateCustomer, licenseShowMessageAlert,
    loadingUpdateCustomer, countriesList,
  } = props;

  const {
    handleSubmit, errors, control, setValue, getValues, watch, reset, formState, setError,
  } = useForm({
    mode: 'onChange',
  });

  const theme = useTheme();

  const watchPersonTypeSer = watch('personTypeService');
  const watchDocTypeSer = watch('documentTypeIdService');
  const watchDocSer = watch('documentNumberService');
  const watchLegalNameSer = watch('legalNameService');
  const watchFirstNameSer = watch('firstNameService');
  const watchLastNameService = watch('lastNameService');
  const watchCellphoneNumberSer = watch('cellphoneNumberService');
  const watchEmailSer = watch('emailService');
  const watchFulladdressSer = watch('fulladdressService');
  const watchDepartmentIdSer = watch('departmentIdService');
  const watchCityIdSer = watch('cityIdService');
  const watchLegalDocTypeSer = watch('legalDocumentTypeIdService');
  const watchDocLeg = watch('legalDocumentNumberService');
  const watchLegalFirstNameSer = watch('legalFirstNameService');
  const watchLegalLastNameSer = watch('legalLastNameService');
  const watchAdditionalInfoService = watch('additionalInfoService');

  const [departaments, setDepartaments] = useState([]);
  const [citiesService, setCitiesService] = useState([]);
  const [personTypeService, setPersonTypeService] = React.useState('N');
  const [checkService, setCheckService] = useState(
    Boolean(customerServiceEditInfoLicense && Object.keys(customerServiceEditInfoLicense).length > 0),
  );
  const [loadingRues] = React.useState(false);
  const [valueDepartamentService, setValueDepartamentService] = React.useState(null);
  const [valueCityService, setValueCityService] = React.useState(null);
  const [geoCodeService, setGeoCodeService] = React.useState({ lat: null, lng: null });
  const [addressMapsService, setAddressMapsService] = React.useState(null);
  const [inputAddressServiceValue, setInputAddressServiceValue] = React.useState('');
  const [optionsAddressService, setOptionsAddressService] = React.useState([]);
  const [disabledSubmit, setDisabledSubmit] = React.useState(true);
  const [openAlertConfirmTicket, setOpenAlertConfirmTicket] = useState(false);
  const [formValuesToSave, setFormValuesToSave] = useState(null);
  const [, setOpenAlertInfo] = useState(false);
  const dialogColorIcon = theme?.miplan?.buttonCard?.backgroundColor;

  const OwnWarningIcon = useMemo(() => (
    <WarningIcon color={dialogColorIcon} />
  ), [dialogColorIcon]);

  const [initialValues, setInitialValues] = useState(null);
  const [valueCountryService, setValueCountryService] = useState(null);
  const [addressLabelService, setAddressLabelService] = useState('Dirección');
  const [stateLabelService, setStateLabelService] = useState('Departamento');
  const [cityLabelService, setCityLabelService] = useState('Ciudad');

  const handleGoToLicenses = () => {
    setEditCustomer(false);
    setIdCustomerEdit(0);
    setShowListCustomers(true);
  };

  useEffect(() => {
    getCustomerEditInformationLicense(idCustomerEdit, '', '');
    resetFormRegister();
    getTokenExternalSource();
  }, []);

  useEffect(() => {
    if (statesAndCities) {
      setDepartaments(statesAndCities.itemsStatesList.sort((a, b) => {
        const x = a.text < b.text ? -1 : 1;
        return x;
      }));
      if (customerServiceEditInfoLicense) {
        setCheckService(true);
      }
    }
  }, [statesAndCities]);

  useEffect(() => {
    const recordData = customerServiceEditInfoLicense?.result?.records || customerServiceEditInfoLicense?.records;

    if (recordData) {
      const currentCountryCode = recordData.countryCode || 'CO';
      getParametersCustomer(currentCountryCode);
    }
  }, [customerServiceEditInfoLicense]);

  useEffect(() => {
    const recordData = customerServiceEditInfoLicense?.result?.records || customerServiceEditInfoLicense?.records;

    if (recordData && statesAndCities && countriesList) {
      const hasData = true;
      setCheckService(hasData);
      setPersonTypeService(recordData.personTypeId || 'N');
      const foundCountry = countriesList.find((c) => c.value === recordData.countryId) || countriesList.find((c) => c.countryCode === 'CO');
      setValueCountryService(foundCountry || null);
      if (foundCountry) {
        setAddressLabelService(foundCountry.addressLabel || 'Dirección');
        setStateLabelService(foundCountry.stateLabel || 'Departamento');
        setCityLabelService(foundCountry.cityLabel || 'Ciudad');
      }

      const convertCityString = recordData.cityId ? recordData.cityId.toString() : '';
      const convertCityInt = convertCityString ? parseInt(convertCityString.slice(0, 6)) : 0;

      const dptoServ = statesAndCities.itemsStatesList.find((d) => d.value === convertCityInt);

      let cityBilling = null;
      if (dptoServ) {
        const newCities = statesAndCities.statesList.find((d) => d.id === convertCityInt);
        if (newCities) {
          setCitiesService(newCities.city);
          cityBilling = newCities.city.find((d) => d.id === recordData.cityId);
        }
      }

      setValueDepartamentService(dptoServ || null);
      setValueCityService(cityBilling || null);

      let calculatedDv = recordData.dv !== undefined && recordData.dv !== null ? recordData.dv : '';
      if (!calculatedDv && recordData.documentTypeId === 4 && recordData.documentNumber) {
        const checkDigit = calculateCheckDigit(recordData.documentNumber);
        if (checkDigit || checkDigit === 0) {
          calculatedDv = checkDigit;
        }
      }

      const formDataValues = {
        personTypeService: recordData.personTypeId || '',
        documentTypeIdService: recordData.documentTypeId || '',
        documentNumberService: recordData.documentNumber || '',
        dvService: calculatedDv,
        firstNameService: recordData.firstName || '',
        lastNameService: recordData.lastName || '',
        legalNameService: recordData.legalName || '',
        cellphoneNumberService: recordData.cellphoneNumber || '',
        emailService: recordData.email || '',
        countryIdService: foundCountry ? foundCountry.value : '',
        departmentIdService: dptoServ ? dptoServ.value : '',
        cityIdService: cityBilling ? cityBilling.id : '',
        fulladdressService: recordData.fullAddress || '',
        additionalInfoService: recordData.addressAdditionalInformation || '',
        legalDocumentTypeIdService: recordData.legalDocumentTypeId || '',
        legalDocumentNumberService: recordData.legalDocumentNumber || '',
        legalFirstNameService: recordData.legalFirstName || '',
        legalLastNameService: recordData.legalLastName || '',
      };

      setInitialValues(formDataValues);
      reset(formDataValues);

      if (hasData && recordData.fullAddress) {
        setAddressCustomer(recordData.fullAddress, setOptionsAddressService, setAddressMapsService, 'fulladdressService', setGeoCodeService);
      }
    }
  }, [customerServiceEditInfoLicense, statesAndCities, countriesList]);

  useEffect(() => {
    if (!initialValues) return;

    const errorCount = Object.getOwnPropertyNames(formState.errors);
    const hasErrors = errorCount.length > 0;

    let missingRequiredFields = false;

    if (watchPersonTypeSer === 'J') {
      if (!watchDocTypeSer || !watchDocSer || !watchLegalNameSer || !watchCellphoneNumberSer
        || !watchEmailSer || !watchFulladdressSer || !watchDepartmentIdSer || !watchCityIdSer
        || !watchLegalDocTypeSer || !watchDocLeg || !watchLegalFirstNameSer || !watchLegalLastNameSer) {
        missingRequiredFields = true;
      }
    } else if (!watchDocTypeSer || !watchDocSer || !watchFirstNameSer || !watchLastNameService
      || !watchCellphoneNumberSer || !watchEmailSer || !watchFulladdressSer || !watchDepartmentIdSer
      || !watchCityIdSer) {
      missingRequiredFields = true;
    }

    const getAddressString = (addr) => {
      if (!addr) return '';
      if (typeof addr === 'string') return addr.trim();
      return (addr.description || addr.structured_formatting?.main_text || '').trim();
    };

    const getIdValue = (val) => {
      if (!val) return '';
      if (typeof val === 'object') {
        return String(val.value || val.id || '');
      }
      return String(val);
    };

    const currentAddress = getAddressString(watchFulladdressSer);
    const initialAddress = getAddressString(initialValues.fulladdressService);

    const currentDpto = getIdValue(watchDepartmentIdSer);
    const initialDpto = getIdValue(initialValues.departmentIdService);

    const currentCity = getIdValue(watchCityIdSer);
    const initialCity = getIdValue(initialValues.cityIdService);

    const hasChanged = String(watchPersonTypeSer || '') !== String(initialValues.personTypeService || '')
      || String(watchDocTypeSer || '') !== String(initialValues.documentTypeIdService || '')
      || String(watchDocSer || '') !== String(initialValues.documentNumberService || '')
      || String(watchFirstNameSer || '') !== String(initialValues.firstNameService || '')
      || String(watchLastNameService || '') !== String(initialValues.lastNameService || '')
      || String(watchLegalNameSer || '') !== String(initialValues.legalNameService || '')
      || String(watchCellphoneNumberSer || '') !== String(initialValues.cellphoneNumberService || '')
      || String(watchEmailSer || '') !== String(initialValues.emailService || '')
      || currentDpto !== initialDpto
      || currentCity !== initialCity
      || currentAddress !== initialAddress
      || String(watchAdditionalInfoService || '') !== String(initialValues.additionalInfoService || '')
      || String(watchLegalDocTypeSer || '') !== String(initialValues.legalDocumentTypeIdService || '')
      || String(watchDocLeg || '') !== String(initialValues.legalDocumentNumberService || '')
      || String(watchLegalFirstNameSer || '') !== String(initialValues.legalFirstNameService || '')
      || String(watchLegalLastNameSer || '') !== String(initialValues.legalLastNameService || '');

    if (!hasChanged || hasErrors || missingRequiredFields) {
      setDisabledSubmit(true);
    } else {
      setDisabledSubmit(false);
    }
  }, [
    initialValues,
    watchPersonTypeSer,
    watchDocTypeSer,
    watchDocSer,
    watchLegalNameSer,
    watchFirstNameSer,
    watchLastNameService,
    watchCellphoneNumberSer,
    watchEmailSer,
    watchFulladdressSer,
    watchDepartmentIdSer,
    watchCityIdSer,
    watchAdditionalInfoService,
    watchLegalDocTypeSer,
    watchDocLeg,
    watchLegalFirstNameSer,
    watchLegalLastNameSer,
    formState.errors,
  ]);

  // ---------------------------------------------
  // method - Setear direccion
  // ---------------------------------------------
  const setAddressCustomer = (valueAddress, setOptionsMaps, setAddressValue, combo, geoCode) => {
    if (valueAddress) {
      const optionsAddress = [];

      optionsAddress.push({
        description: valueAddress,
        structured_formatting: {
          main_text: valueAddress,
          main_text_matched_substrings: [
            {
              length: 0,
              offset: 0,
            },
          ],
          secondary_text: '',
        },
      });

      setOptionsMaps(optionsAddress);
      if (optionsAddress.length > 0) {
        setAddressValue(optionsAddress[0]);
        setValue(combo, optionsAddress[0]);
        setGeoCode(valueAddress, geoCode);
      }
    }
  };
  // ---------------------------------------------
  // method - Setear ciudad cliente servicio
  // ---------------------------------------------
  const setCityCustomerServiceId = (dptoId, dptoName, cityId, cityName, checkServ) => {
    setValueDepartamentService(null);
    setValueCityService(null);
    if (checkServ) {
      let dptoServ = {};
      if (dptoId > 0) {
        dptoServ = statesAndCities.itemsStatesList.find((d) => d.value === dptoId);
      } else {
        dptoServ = statesAndCities.itemsStatesList.find((d) => d.text === dptoName);
      }

      if (dptoServ) {
        setValueDepartamentService(dptoServ);
        setValue('departmentIdService', dptoServ.value);
      }

      let newCities = {};
      if (dptoId > 0) {
        newCities = statesAndCities.statesList.find((d) => d.id === dptoId);
      } else {
        newCities = statesAndCities.statesList.find((d) => d.stateName === dptoName);
      }
      if (newCities) {
        setCitiesService(newCities.city);

        let cityBilling = {};
        if (cityId > 0) {
          cityBilling = newCities.city.find((d) => d.id === cityId);
        } else {
          cityBilling = newCities.city.find((d) => d.cityName === cityName);
        }

        if (cityBilling) {
          setValueCityService(cityBilling);
          setValue('departmentIdService', dptoServ.value);
          setValue('cityIdService', cityBilling.id);
        }
      }
    }
  };

  const resetForm = () => {
    setValue('fulladdressService', '');
    setOptionsAddressService([]);
    setAddressMapsService(null);
    setInputAddressServiceValue('');
    setValueDepartamentService(null);
    setValueCityService(null);
    setValue('departmentIdService', null);
    setValue('cityIdService', '');
    reset();
  };

  useEffect(() => {
    if (citiesServGoogleAssistant && citiesServGoogleAssistant.deptoName !== null) {
      setCityCustomerServiceId(0, citiesServGoogleAssistant.deptoName, 0, citiesServGoogleAssistant.cityName, true);
    } else if (addressMapsService && optionsAddressService.length > 3 && !checkService) {
      setValueDepartamentService(null);
      setValueCityService(null);
      setValue('departmentIdService', '');
      setValue('cityIdService', '');
    }
  }, [citiesServGoogleAssistant]);

  useEffect(() => {
    if (licenseShowMessageAlert) {
      setOpenAlertConfirmTicket(false);
      setOpenAlertInfo(true);

      const { category, typeMsg } = licenseShowMessageAlert;
      switch (category) {
        case 'license':
          resetForm();
          break;
        default:
          break;
      }
      if (typeMsg === 'Success') {
        setInterval(() => { window.location.reload(); }, 3000);
      }
    }
  }, [licenseShowMessageAlert]);

  // ---------------------------------------------
  // method - setear tipo de persona
  // ---------------------------------------------
  const setPersonType = (event) => {
    const { value } = event.target;

    if (event.target.name === 'personTypeService') {
      setPersonTypeService(value);
      if (value === 'J') {
        setValue('documentTypeIdService', 4);
      }
    }
    if (value === 'N') {
      setValue('legalDocumentTypeIdService', '');
      setValue('legalDocumentNumberService', '');
      setValue('legalFirstNameService', '');
      setValue('legalLastNameService', '');
    }
    return value;
  };

  // ---------------------------------------------
  // event envio de datos de formulario
  // ---------------------------------------------
  const onSubmit = (formData) => {
    setFormValuesToSave(formData);
    setOpenAlertConfirmTicket(true);
  };

  // ---------------------------------------------
  // event handler cambio de estado cliente
  // ---------------------------------------------
  const handleChangeStateCustomerServiceId = (idDepartament) => {
    setValueCityService(null);
    const newCities = statesAndCities.statesList.find((d) => d.id === idDepartament);
    if (newCities) {
      setCitiesService(newCities.city.sort((a, b) => {
        const x = a.cityName < b.cityName ? -1 : 1;
        return x;
      }));
    }
    return idDepartament;
  };

  // ---------------------------------------------
  // validación documento
  // ---------------------------------------------
  const validateDocument = (persontype, watchDocType) => {
    if (watchDocType === 6) {
      return Rules.pasaporte;
    } if (watchDocType === 4 && persontype === 'J') {
      return Rules.tipoDocumentoNIT;
    }
    return Rules.otrosDocumentos;
  };

  const validateDoc = (docType, e) => {
    const alfanumerico = /[a-zA-Z0-9]/gi;
    const numerico = /[0-9]/gi;
    if (docType === 6) {
      if (!e.key.match(alfanumerico)) {
        e.preventDefault();
      }
    } else if (!e.key.match(numerico)) {
      e.preventDefault();
    }
  };
  const handleKeyDown = (e, watchDocType) => {
    const { keyCode } = e;
    if (keyCode === 9 || keyCode === 8 || keyCode === 17 || keyCode === 37 || keyCode === 39 || keyCode === 46) return;
    validateDoc(watchDocType, e);
  };

  const setDocumentType = () => {
    const documents = documentTypes;
    const docTypes = [];
    if (documents.length > 0) {
      documents.map((doc, index) => (
        docTypes.push({
          id: index,
          label: doc.text,
          value: doc.value,
        })
      ));
    }
    return docTypes;
  };

  const setDocumentTypeLegalRep = () => {
    let documents = [];
    const docTypes = [];
    documents = documentTypes.filter((doc) => doc.value === 1 || doc.value === 2 || doc.value === 6);

    if (documents.length > 0) {
      documents.map((doc, index) => (
        docTypes.push({
          id: index,
          label: doc.text,
          value: doc.value,
        })
      ));
    }
    return docTypes;
  };

  const getLoading = () => (
    <>
      <Grid item xs={1} sm={1}>
        <CircularProgress size={24} className={classes.buttonProgress} />
      </Grid>
    </>
  );

  const boxCheckDigit = (referencia) => (
    <>
      <Grid item xs={1} sm={1}>
        <Box pt={1} style={{ textAlign: 'center' }}>-</Box>
      </Grid>
      <Grid item xs={2} sm={2}>
        <Controller
          as={(
            <TextField
              size="small"
              label="Dv"
              disabled
              variant="outlined"
              style={{ color: 'red' }}
              className={classes.typeInput}
            />
          )}
          name={referencia}
          control={control}
          defaultValue=""
        />
      </Grid>
    </>
  );

  const skipEnterPress = (e) => {
    if (e.which === 13) {
      e.preventDefault();
    }
  };

  const handleOnchangeDepartament = (data) => {
    setValueDepartamentService(data);
    handleChangeStateCustomerServiceId(data.value);
  };

  const handleOnchangeCity = (data) => {
    setValueCityService(data);
  };

  const handleCancelModifyTicket = () => {
    setOpenAlertConfirmTicket(false);
  };

  const handleConfirmTicket = () => {
    const ticket = getValues('ticketService');
    const observations = getValues('observations');

    if (!ticket) {
      setError('ticketService', {
        type: 'required',
        message: 'Campo obligatorio',
      });
    }
    if (!observations) {
      setError('observations', {
        type: 'required',
        message: 'Campo obligatorio',
      });
    }
    if (!ticket || !observations) {
      return;
    }

    const completeData = {
      ...formValuesToSave,
      ticketService: ticket,
      observations,
      idCustomerEdit,
    };
    updateCustomer(completeData, geoCodeService, ImagePopup, WarningPopup);
  };

  const handleOnchangeCountry = (data) => {
    const recordData = customerServiceEditInfoLicense?.result?.records || customerServiceEditInfoLicense?.records;
    const originalCountryId = recordData ? recordData.countryId : null;

    const originalCountry = countriesList.find((c) => c.value === originalCountryId) || countriesList.find((c) => c.countryCode === 'CO');
    if (!data || data.value !== originalCountryId) {
      setValueCountryService(originalCountry || null);
      setValue('countryIdService', originalCountryId);
      return;
    }
    setValueCountryService(originalCountry);
    setValue('countryIdService', originalCountryId);
  };

  if (loadingCustomerEdit || loading) return <Loading />;
  return (
    <>
      <Container component="main" maxWidth="lg">
        <Paper elevation={3} className={classes.paper}>
          <Typography color="primary" variant="h4" className={classes.title}>Licencias y consumos</Typography>
          <Container component="main" maxWidth="lg">
            <Paper elevation={3} className={classes.paperGroup}>
              <form
                className={classes.form}
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit(onSubmit)}
                onKeyPress={(e) => skipEnterPress(e)}
              >
                <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Grid item xs="auto">
                    <IconButton color="primary" onClick={(e) => handleGoToLicenses(e)} style={{ color: '#E5521A' }}>
                      <ArrowBackIosIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" className={classes.titleForm} variant="h5">
                      Datos de empresa
                    </Typography>
                  </Grid>
                </Grid>
                {/*  */}
                <Grid container spacing={4} style={{ paddingLeft: '60px', paddingRight: '60px' }}>
                  <Grid item xs={12} />
                  <Grid item xs={12} md={6}>
                    <CustomAutocompleteSelect
                      name="countryIdService"
                      options={countriesList || []}
                      label="País"
                      disableClearable
                      disabled
                      value={valueCountryService}
                      getOptionLabel={(option) => option.text || ''}
                      required
                      FormHelperTextProps={{ style: { marginRight: 10 } }}
                      handleOnchange={handleOnchangeCountry}
                      control={control}
                      rule={Rules.required}
                      error={errors}
                      className={classes.typeInput}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} />
                  <Grid item xs={12} md={3}>
                    <InputLabel />
                    <CustomSelect
                      label="Tipo de persona"
                      name="personTypeService"
                      options={personType}
                      control={control}
                      required
                      rule={Rules.required}
                      error={errors}
                      styleFromHelperText={{ style: { marginRight: 10 } }}
                      inputProps={{ onChange: (e) => setPersonType(e) }}
                      classes={classes.typeInput}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Grid container>
                      <Grid item xs={12} md={loadingRues ? 11 : 12} lg={loadingRues ? 11 : 12}>
                        <InputLabel />
                        <CustomSelect
                          label="Tipo de documento"
                          name="documentTypeIdService"
                          options={setDocumentType()}
                          control={control}
                          required
                          rule={Rules.required}
                          error={errors}
                          styleFromHelperText={{ style: { marginRight: 10 } }}
                          inputProps={{ onChange: (e) => setPersonType(e) }}
                          classes={classes.typeInput}
                          disabled
                        />
                      </Grid>
                      {loadingRues && getLoading()}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Grid container>
                      <Grid item xs={watchDocTypeSer === 4 ? 9 : 12} sm={watchDocTypeSer === 4 ? 9 : 12}>
                        <CustomInput
                          label="Número de documento"
                          name="documentNumberService"
                          control={control}
                          rule={validateDocument(personTypeService, watchDocTypeSer)}
                          error={errors}
                          required
                          styleFromHelperText={{ style: { marginRight: 10 } }}
                          onKeyDown={(e) => handleKeyDown(e, watchDocTypeSer)}
                          classes={classes.typeInput}
                          disabled
                        />
                      </Grid>
                      {watchDocTypeSer === 4 ? boxCheckDigit('dvService') : ''}
                    </Grid>
                  </Grid>
                  {
                    personTypeService === 'J'
                      ? (
                        <Grid item xs={12}>
                          <CustomInput
                            label="Razón Social"
                            name="legalNameService"
                            control={control}
                            rule={Rules.DenySpecialCharactersLegalName}
                            error={errors}
                            required
                            styleFromHelperText={{ style: { marginRight: 10 } }}
                            inputProps={{
                              maxLength: 450,
                            }}
                            classes={classes.typeInput}
                          />
                        </Grid>
                      )
                      : (
                        <>
                          <Grid item xs={12} md={6}>
                            <CustomInput
                              label="Nombres"
                              name="firstNameService"
                              control={control}
                              rule={Rules.letrasTildesMin3}
                              error={errors}
                              required
                              styleFromHelperText={{ style: { marginRight: 10 } }}
                              inputProps={{
                                maxLength: 100,
                              }}
                              classes={classes.typeInput}
                            />
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <CustomInput
                              label="Apellidos"
                              name="lastNameService"
                              control={control}
                              rule={Rules.letrasTildesMin3}
                              error={errors}
                              required
                              styleFromHelperText={{ style: { marginRight: 10 } }}
                              inputProps={{
                                maxLength: 100,
                              }}
                              classes={classes.typeInput}
                            />
                          </Grid>
                        </>
                      )
                  }
                  <Grid item xs={12} md={6}>
                    <CustomInput
                      label="Teléfono / Celular"
                      name="cellphoneNumberService"
                      control={control}
                      rule={Rules.telCel}
                      error={errors}
                      required
                      styleFromHelperText={{ style: { marginRight: 10 } }}
                      inputProps={{
                        maxLength: 10,
                      }}
                      classes={classes.typeInput}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <CustomInput
                      label="Correo Electrónico"
                      name="emailService"
                      control={control}
                      rule={Rules.email}
                      error={errors}
                      required
                      styleFromHelperText={{ style: { marginRight: 10 } }}
                      inputProps={{
                        maxLength: 100,
                      }}
                      classes={classes.typeInput}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <AutocompleteGoogleMaps
                      name="fulladdressService"
                      options={optionsAddressService}
                      label={addressLabelService}
                      placeholder="Escriba la dirección"
                      value={addressMapsService}
                      setOptions={setOptionsAddressService}
                      setValueMaps={setAddressMapsService}
                      inputValue={inputAddressServiceValue}
                      setInputValue={setInputAddressServiceValue}
                      setGeoCoordinate={setGeoCodeService}
                      type="Service"
                      showIconLocation
                      control={control}
                      rules={Rules.required}
                      error={errors}
                      className={classes.typeInput}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocompleteSelect
                      name="departmentIdService"
                      options={departaments}
                      label={stateLabelService}
                      disableClearable
                      value={valueDepartamentService}
                      getOptionLabel={(option) => option.text}
                      required
                      FormHelperTextProps={{ style: { marginRight: 10 } }}
                      handleOnchange={handleOnchangeDepartament}
                      control={control}
                      rule={Rules.required}
                      error={errors}
                      className={classes.typeInput}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocompleteSelect
                      name="cityIdService"
                      options={citiesService}
                      label={cityLabelService}
                      disableClearable
                      value={valueCityService}
                      getOptionLabel={(option) => option.cityName}
                      required
                      FormHelperTextProps={{ style: { marginRight: 10 } }}
                      handleOnchange={handleOnchangeCity}
                      control={control}
                      rule={Rules.required}
                      error={errors}
                      className={classes.typeInput}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomInput
                      label="Información adicional"
                      name="additionalInfoService"
                      control={control}
                      error={errors}
                      inputProps={{
                        maxLength: 100,
                      }}
                      classes={classes.typeInput}
                    />
                    <Typography
                      style={{ paddingLeft: '5px', fontSize: '12px' }}
                      className={classes.contentInfoAddress}
                    >
                      Ejemplo: Interior, apartamento, conjunto residencial, barrio, etc.
                    </Typography>
                  </Grid>
                  {
                    personTypeService === 'J'
                      ? (
                        <>
                          <Grid item xs={12}>
                            <h3 className={classes.contentTextPrimary}>Datos representante legal</h3>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <CustomSelect
                              label="Tipo de documento Representante Legal"
                              name="legalDocumentTypeIdService"
                              options={setDocumentTypeLegalRep()}
                              control={control}
                              required
                              rule={Rules.required}
                              error={errors}
                              styleFromHelperText={{ style: { marginRight: 10 } }}
                              classes={classes.typeInput}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <CustomInput
                              label="Número de documento Representante Legal"
                              name="legalDocumentNumberService"
                              control={control}
                              rule={validateDocument('J', watchLegalDocTypeSer)}
                              error={errors}
                              required
                              styleFromHelperText={{ style: { marginRight: 10 } }}
                              onKeyDown={(e) => handleKeyDown(e, watchLegalDocTypeSer)}
                              inputProps={{ maxLength: 15 }}
                              classes={classes.typeInput}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <CustomInput
                              label="Nombres Representante Legal"
                              name="legalFirstNameService"
                              control={control}
                              rule={Rules.letrasTildesMin3}
                              error={errors}
                              required
                              styleFromHelperText={{ style: { marginRight: 10 } }}
                              inputProps={{
                                maxLength: 100,
                              }}
                              classes={classes.typeInput}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <CustomInput
                              label="Apellidos Representante Legal"
                              name="legalLastNameService"
                              control={control}
                              rule={Rules.letrasTildesMin3}
                              error={errors}
                              required
                              styleFromHelperText={{ style: { marginRight: 10 } }}
                              inputProps={{
                                maxLength: 100,
                              }}
                              classes={classes.typeInput}
                            />
                          </Grid>
                          <Grid item xs={12} />
                        </>
                      )
                      : (
                        <>
                        </>
                      )
                  }
                </Grid>
                <Box className={classes.submit}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="medium"
                    className={classes.btnSubmit}
                    disabled={disabledSubmit}
                  >
                    Editar
                  </Button>
                </Box>
              </form>
            </Paper>
            <ObservationsConfirm
              isOpen={openAlertConfirmTicket}
              textTitle="Ingresa el Número del ticket"
              firstImage={OwnWarningIcon}
              objControl={{
                control,
                errors,
              }}
              objInputs={{
                label1: 'Número de ticket',
                name1: 'ticketService',
                label2: 'Observaciones',
                name2: 'observations',
              }}
              objButtons={{
                textCancel: 'Cancelar',
                textAccept: loadingUpdateCustomer ? (
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  }}
                  >
                    <CircularProgress size={20} style={{ color: '#FFF' }} />
                    <span>Cargando...</span>
                  </div>
                ) : 'Editar empresa',
                handleCancel: () => {
                  if (loadingUpdateCustomer) return;
                  handleCancelModifyTicket();
                },
                handleAccept: () => {
                  if (loadingUpdateCustomer) return;
                  handleConfirmTicket();
                },
                styleButtonAccept: {
                  width: '140px',
                  backgroundColor: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
                  color: '#FFFF',
                  opacity: loadingUpdateCustomer ? 0.7 : 1,
                  cursor: loadingUpdateCustomer ? 'wait' : 'pointer',
                },
                styleButtonCancel: {
                  backgroundColor: '#FFFFFF',
                  color: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
                  border: `1px solid ${theme?.backOffice?.contracts?.btnSteps?.backgroundColor}`,
                  width: '116px',
                  opacity: loadingUpdateCustomer ? 0.4 : 1,
                  pointerEvents: loadingUpdateCustomer ? 'none' : 'auto',
                  cursor: loadingUpdateCustomer ? 'not-allowed' : 'pointer',
                },
              }}
            />
            {
              licenseShowMessageAlert && (
                <AlertConfirm licenseShowMessageAlert={licenseShowMessageAlert} />
              )
            }
          </Container>
        </Paper>
      </Container>
    </>
  );
};

const mapStateToProps = (props) => ({
  userInfo: props.auth.userInfo,
  billingInfo: props.purchaseLicense.customerBillingInfo,
  licenseShowMessageAlert: props.general.showMessageAlert,
  documentTypes: props.general.documentTypes,
  statesAndCities: props.general.statesAndCities,
  appName: props.general.appName,
  citiesServGoogleAssistant: props.google.citiesServGoogleAssistant,
  loadingCustomerEdit: props.license.loadingCustomerEdit,
  customerServiceEditInfoLicense: props.license.customerServiceEditInfoLicense,
  loading: props.general.loading,
  loadingUpdateCustomer: props.license.loadingUpdateCustomer,
  countriesList: props.general.countriesList,
});

const mapDispatchToProps = {
  getParametersCustomer: getParametersCustomerAction,
  getCustomerInformationLicense: getCustomerInformationLicenseAction,
  getTokenExternalSource: getTokenExternalSourceAction,
  resetFormRegister: resetFormRegisterAction,
  updateCustomer: updateCustomerAction,
  getCustomerEditInformationLicense: getCustomerEditInformationLicenseAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCustomer);
